import { __awaiter } from "tslib";
import $store from '@/store';
import services from '@/services';
import { setTrueFieldsNamesPositions } from '@/store/modules/mainPageModules/actionsHelpers/positions/helpers';
import { setTrueFieldsNamesSpot } from '@/store/modules/mainPageModules/actionsHelpers/limitsBids/helpers';
import _ from 'lodash';
export function _getLeverageByName(leverageName) {
    const list = $store.getters['leverages/getLeveragesBody'];
    let result = null;
    for (const folder of list) {
        for (const leverage of folder.items) {
            if (leverage.name.toUpperCase() === leverageName.toUpperCase())
                result = leverage;
        }
    }
    return result;
}
function synchronizeLimitBidsAndPositionsOrigin(commit) {
    return __awaiter(this, void 0, void 0, function* () {
        const responsePositions = yield services.mainService.getPositionsTableData(null);
        if (responsePositions.success) {
            commit('setWidgetProperty', {
                name: 'positionsTable',
                field: 'isRetry',
                data: false
            });
            commit('setWidgetProperty', {
                name: 'positionsTable',
                field: 'items',
                data: setTrueFieldsNamesPositions(responsePositions.data)
            });
        }
        const limitBidsResponse = yield services.mainService.getBidsTableData(null);
        if (limitBidsResponse.success) {
            commit('setWidgetProperty', {
                name: 'limitsBidsTable',
                field: 'isRetry',
                data: false
            });
            commit('setWidgetProperty', {
                name: 'limitsBidsTable',
                field: 'items',
                data: setTrueFieldsNamesSpot(limitBidsResponse.data)
            });
        }
    });
}
export const synchronizeLimitBidsAndPositions = _.debounce(synchronizeLimitBidsAndPositionsOrigin, 1500);
